import axios from "axios";
import { backendDomain } from "utils/envConfig";

export default axios.create({
  baseURL: `${backendDomain}`,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json",
  },
});
